import { ReportMenu } from './../../shared/entities/report-menu.entity';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { SubscriptionsManager } from 'src/app/shared/helpers/subscriptions-manager';

import {
  loadNavigation,
} from 'src/app/shared/stores/actions/navigation.actions';

import {
  selectEnabledRoutes,
  selectSelectedRoute,
} from 'src/app/shared/stores/selectors/navigation.selector';
import { selectCurrentUser } from 'src/app/shared/stores/selectors/user.selectors';
import { AppState, AppUserState } from 'src/app/shared/stores/states/app.state';
import * as NavigationActions from 'src/app/shared/stores/actions/navigation.actions';
import { distinctUntilChanged } from 'rxjs';
import { createUrlFriendlyName } from 'src/app/shared/utils/url-utils';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isSlimMode = false;
  @Output() isSlimModeChange = new EventEmitter<boolean>();

  initialized = false;
  currentUser!: AppUserState;
  draftCounter = 0;
  navigation: ReportMenu[] = [];
  selectedRoute!: ReportMenu;
  hasWritebackHistoryAccess = false;
  hasProjectSummaryAccess = false;
  // hasExecutiveOrdersAccess = false;

  private screenThreshold: number = 1200;
  private subsManager = new SubscriptionsManager();

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {
    this.checkScreenSize(window.innerWidth);
    this.subsManager.add(
      this.store.pipe(select(selectCurrentUser), distinctUntilChanged()).subscribe((currentUser) => {
        this.currentUser = currentUser;
      }),
    );
    this.subsManager.add(
      this.store.pipe(select(selectEnabledRoutes), distinctUntilChanged()).subscribe((routes) => {
        this.navigation = routes;
        if (routes.length && !this.initialized) {
          this.loadNavigationPermissions(routes);
          this.initialized = true;
        }
      }),
    );
    this.subsManager.add(
      this.store.pipe(
        select(selectSelectedRoute),
        distinctUntilChanged()).subscribe((route) => {
          if (route) {
            this.selectedRoute = route;
          }
        }));
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize(event.target.innerWidth);
  }

  private checkScreenSize(width: number) {
    if (width < this.screenThreshold) {
      this.isSlimMode = true;
    }
  }

  toggleSidebar(): void {
    this.isSlimModeChange.emit(!this.isSlimMode);
  }

  goHome() {
    // Clear selected route when going home
    this.store.dispatch(NavigationActions.deselectRoute());
    this.router.navigate(['/'], {
      queryParams: {},
      replaceUrl: true
    });
  }
  loadNavigationPermissions(navigation: any) {
    this.hasWritebackHistoryAccess = navigation.some((obj: any) =>
      obj.reports.some((report: any) => {
        const permissions = report.permissions || {};
        return permissions.use_writebacks ?? false;
      })
    );

    this.hasProjectSummaryAccess = navigation.some((obj: any) =>
      obj.reports.some((report: any) => {
        const permissions = report.permissions || {};
        return permissions.use_projectsummary ?? false;
      })
    );

    // this.hasExecutiveOrdersAccess = navigation.some((obj: any) =>
    //   obj.reports.some((report: any) => {
    //     const permissions = report.permissions || {};
    //     return permissions.use_executiveorders ?? false;
    //   })
    // );
  }

  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    this.subsManager.unsubscribeAll();
  }
  ngAfterViewInit(): void {
    this.initNavigation();
    this.cdr.detectChanges();
  }
  isActive(routePath: string): boolean {
    const currentPath = `/${this.router.url.split('?')[0].split('/')[1]}`;
    const isActive = currentPath === routePath;

    if (isActive) {
      this.selectedRoute = { uuid: '', iconName: '', menuName: '', role: '', reports: [] } as ReportMenu;
    }

    return isActive;
  }
  isActiveReport(uuid: string | null) {
    if (!uuid) {
      return false;
    }
    return uuid === this.selectedRoute?.uuid;
  }
  initNavigation() {
    this.store.dispatch(loadNavigation({ role: this.currentUser.role }));
  }
  onReportClick(route: ReportMenu) {
    this.store.dispatch(NavigationActions.selectRoute({ route }));
    this.selectedRoute = route;

    // Create URL-friendly report name for query parameter
    const urlFriendlyName = createUrlFriendlyName(route.menuName);

    if (!this.isActive('')) {
      // Navigate to dashboard with query parameter
      this.router.navigate(['/dashboard'], {
        queryParams: { report: urlFriendlyName },
        replaceUrl: true
      });
    } else {
      // Already on dashboard, just update query parameter
      this.router.navigate([], {
        relativeTo: null,
        queryParams: { report: urlFriendlyName },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }
  hasRole(role: string): boolean {
    return this.currentUser?.role?.toLowerCase() === role.toLowerCase();
  }
}
